import React from "react";

import RewardsBenefits from "../rewardsBenefits/rewardsBenefits";
import TravelProtection from "../travelProtection/travelProtection";
import AdditionalBenefits from "../additionalBenefits/additionalBenefits";
import Disclosure from "../disclosure/disclosure";

const Benefits = (props) => {
  document.title = props.title;

  const legalParagraphs = [
    `Safeguard your new item against theft or damage due to fire,
    vandalism or accidentally discharged water or certain weather conditions within
    the first 90 days from the date of purchase with Purchase Security, available when
    you pay for your eligible item with your covered card. Additional terms, conditions
    and exclusions apply. In order for coverage to apply, you must use your covered
    account and/or rewards program associated with the covered account to secure
    transactions. If your credit card application is approved, you will be provided with a
    link to a Visa Guide to Benefits that contains complete details regarding the benefit
    program.`,
    `When you pay your monthly wireless bill with your eligible PNC Visa
    credit card, your cell phone is protected for the next calendar month if it is stolen
    or damaged. A maximum of 2 claims will be paid each 12-month period, with each
    claim subject to a $50 deductible. Additional terms, conditions and exclusions
    apply. See your <a href="https://www.pnc.com/content/dam/pnc-com/pdf/personal/CreditCards/PNC-points-Visa-Guide-to-Benefits.pdf" target="_blank" rel="noopener noreferrer">Visa Guide to Benefits</a> for complete program details.`,
    `If an eligible item you bought is stolen or damaged due to a covered
    circumstance within 90 days of purchase, your item can be repaired, replaced or
    reimbursed.`,
    `<div id='see-points-rewards'>See PNC points Rewards <a href="https://www.pnc.com/content/dam/pnc-com/pdf/personal/CreditCards/points-rewards.pdf" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> for full details.</div>`,
    `<div id='limitations-apply'>Limitations apply. Notify PNC Bank immediately of any unauthorized use. For specific time restrictions, limitations, and other details regarding unauthorized use, see your account agreement.</div>`,
    `<div id="travel-and-emergency">Travel and Emergency Assistance Services Roadside dispatch – Get help coordinating medical, legal, and travel services while you’re away from home.<br> ****Certain terms, conditions and exclusions apply”. <br>Please refer to your <a href="https://www.pnc.com/content/dam/pnc-com/pdf/personal/CreditCards/PNC-points-Visa-Guide-to-Benefits.pdf" target="_blank" rel="noopener noreferrer">guide to benefits</a> for further details.</div>`
  ]
  return (
    <>
      <RewardsBenefits />
      <TravelProtection />
      <AdditionalBenefits />
      <Disclosure content={legalParagraphs}/>
    </>
  );
};

export default Benefits;
